//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState, useContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';

// === COMPONENTS ===
import { ExpressionContext   } from 'pages/DocAnalytics/RuleView/components/ExpressionContext/ExpressionContext';
import { TablesMatchControl  } from './components/TableMatch/TableMatch';
import { HasDocumentControls } from './components/HasDocuments/HasDocuments';

// === UTILS ===

//#endregion

//-----------------------------------------------------------------
export function FunctionControls( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { id, data, is_predicate } = props;

  const _function_items = [
    { label: 'Has Document' , value: 'DOCUMENT_EXISTS' },
    { label: 'Tables Match' , value: 'TableMatch'      },
  ]

  const { updateExpression, updatePredicate } = useContext( ExpressionContext );

  const [ function_name, setFunctionName ] = useState( data?.name );

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    container: {
      gridColumn: 3,
      gridRow: 1,
      // // -----
      display: 'grid',
      width:'100%',
      rowGap: '1rem',
      gridTemplateColumns:'1fr',
      gridTemplateRows:'1fr auto'
    },
    container2: {
      gridColumn: 1,
      gridRow: 2,
    },
    select_function: {
      gridRow: 1,
      width: '13rem',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
    button_add: {
      backgroundColor: theme.palette.primary[theme.palette.mode],
      color: 'white'
    },
    button_expand: {
      width  : '3rem',
      height : '3rem',
    },
  }

  const SELECT_FUNCTION = {
    sx       : _styles.select_function,
    labelId  : 'function-label',
    id       : 'function-select',
    options  : _function_items,
    value    : function_name,
    size     : 'small',
    onChange : onChange,
    children : _function_items.map( item => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>),
    name     : 'da_predicate_function_select',
  };
    
  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function onChange( event, value ) {
    //-----------------------------------------------------------------
    setFunctionName( event.target.value );
  
    const update = is_predicate ? updatePredicate : updateExpression;
    update( id , { name: event.target.value } )
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div style={_styles.container}>
        <FormControl>
          <InputLabel id="function-label">Function</InputLabel>
          <Select   { ...SELECT_FUNCTION } />
        </FormControl>
        <div style={_styles.container2}>
          {displayControls()}
        </div>
      </div>
    );
  }

  //-----------------------------------------------------------------
  function displayControls() {
    //-----------------------------------------------------------------
    if( function_name === 'DOCUMENT_EXISTS' ) return <HasDocumentControls id={id} is_predicate={is_predicate} />;
    if( function_name === 'TableMatch'      ) return <TablesMatchControl  id={id} data={data} is_predicate={is_predicate} />;
    return null;
  }

  //#endregion

  return display();
}
